import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import axiosWrapper from "../services/axiosWrapper";
import { Query } from "@syncfusion/ej2-data";
import { getDataManagerObj, includedProjectsUrl } from "../services/dataManager";
import {
  setProjectData as setProjectDataAction,
  setAllSpacesInProjects as setAllSpacesInProjectsAction,
  setSpaceData as setSpaceDataAction,
  setBreadCrumbData as setBreadCrumbDataAction,
} from "../reducers/breadcrumbsdata";
export const setProjectData = setProjectDataAction;
export const setAllSpacesInProjects = setAllSpacesInProjectsAction;

export const setBreadCrumbData = setBreadCrumbDataAction;

export function getCurrProjectData(id) {
  return async (dispatch) => {
    const query = new Query().where("_id", "equal", id);
    let response = await getDataManagerObj(includedProjectsUrl).executeQuery(query);
    response = response.result[0];

    if (response?.image != "") {
      dispatch(
        setProjectData({
          ...response,
          projectImageUrl: getUrlForImage({ id }, "projectImage"),
        }),
      );
    } else {
      dispatch(setProjectData({ ...response }));
    }
  };
}

export function getCurrSpaceData(id) {
  return (dispatch) => {
    axiosWrapper
      .get(`${getBackendUrl()}/spaces/getSpaceById/${id}`)
      .then((res) => {
        const spaceData = res.data;
        return spaceData;
      })
      .then((res) => dispatch(setSpaceDataAction(res.data)))
      .catch(() => {
        /* noop */
      });
  };
}

export function getSpaceDataBySpaceId(id) {
  return async (dispatch) => {
    axiosWrapper
      .get(`${getBackendUrl()}/spaces/getSpaceById/${id}`)
      .then((res) => {
        dispatch(setSpaceDataAction(res.data));
      })
      .catch((err) => console.log("ERROR IN GETSPACEDATABYSPACEID ", err));
  };
}
